import type { Facility } from '../../utils/utils';

interface FacilityIdentityCellProps {
    facility: Facility;
}

export default function FacilityIdentityCell({
    facility,
}: FacilityIdentityCellProps) {
    return (
        <div>
            <p className="text-sm font-medium leading-5 text-foreground">
                {facility.name}
            </p>
            {facility.region && (
                <p className="text-xs text-muted-foreground">
                    {facility.region}
                </p>
            )}
        </div>
    );
}
